import React from 'react';
import Loader from './Loader';
import RegisterCoursesUnitDetailsLoader from './RegisterCoursesUnitDetailsLoader'
class RegisterCoursesLoader extends React.Component {
  componentDidMount() {
    // get global jQuery object for use within component
    this.$ = window.$ || window.jQuery;
    // configure course overview slider using local jQuery object
    this.$(this.courseOverviewSlider).owlCarousel({
      items: 4,
      loop: false,
      margin: 20,
      dots: false,
      navText: [
        "<i class='fa fa-long-arrow-left'></i>",
        "<i class='fa fa-long-arrow-right'></i>"
      ],
      responsiveClass: true,
      responsive: {
        0: {
          items: 1,
          nav: true
        },
        480: {
          items: 1,
          nav: true
        },
        576: {
          items: 1,
          nav: true
        },
        768: {
          items: 2,
          nav: true
        },
        992: {
          items: 3,
          nav: true
        },
        1200: {
          items: 4,
          nav: false,
          loop: false
        }
      }
    });
  }

  render() {
    let { input } = this.props;
    return (
      <main className="main-content-area col col-12 col-xs-9 col-sm-8 col-md-9 col-lg-10 col-xl-10">
        <h1> {input ? 'Register' : 'Registered'} Courses</h1>
        {/* card for course max/min credit unit, total registerable, c/o & outstanding courses  */}
        <RegisterCoursesUnitDetailsLoader/>
        <div className="row no-gutters">
          <div className="col-lg-12">
            <div className="card min-h-1000">
              {input ? <div className="card-header">
                <div className="row no-gutters">
                  <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                    My Courses
                    <span className="bar-separator">
                      <select className="short">
                        <option>Semester</option>
                      </select>
                    </span>
                  </div>
                  <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 text-right">
                    <button className="btn btn-solid">
                      <i className="fas fa-plus mr-1" /> Add Course(s)
                    </button>
                  </div>
                </div>
              </div> : <div className="card-header">
                  <div className="row no-gutters">
                    <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 pt-3">
                      My Courses
                </div>
                    <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 text-right">
                      <select
                        onChange={(e) => { this.setState({ semester: e.target.value }) }}
                        className="short">
                        <option value='first'> Semester</option>
                      </select>
                    </div>
                  </div>
                </div>}
              <div className="card-body p-0 m-0">
                <div className="table-responsive">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th scope="col" width={80} className="pl-41">
                          <div className="custom-checkbox">
                            {input ? <> <input
                              type="checkbox"
                              defaultValue={1}
                              id="course_0"
                              name="courses[]"
                            />
                              <label htmlFor="course_0" /> </>
                              : null}
                          </div>
                        </th>
                        <th scope="col" width={100}>
                          Code
                        </th>
                        <th scope="col" width={420}>
                          Course Title
                        </th>
                        <th scope="col" width={100}>
                          Unit
                        </th>
                        <th scope="col" width={80}>
                          Status
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th scope="row">
                          <div className="custom-checkbox">
                            {input ?
                              <>
                                <input
                                  type="checkbox"
                                  defaultValue={1}
                                  id="course_1"
                                  name="courses[]"
                                />
                                <label htmlFor="course_1" />
                              </> : null}
                          </div>
                        </th>
                        <td>
                          <Loader width="300" height="70" />
                        </td>
                        <td>
                          <Loader width="300" height="20" />
                        </td>
                        <td>
                          <Loader width="300" height="70" />
                        </td>
                        <td>
                          <Loader width="300" height="70" />
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">
                          <div className="custom-checkbox">
                            {input ?
                              <>
                                <input
                                  type="checkbox"
                                  defaultValue={1}
                                  id="course_1"
                                  name="courses[]"
                                />
                                <label htmlFor="course_1" />
                              </> : null}
                          </div>
                        </th>
                        <td>
                          <Loader width="300" height="70" />
                        </td>
                        <td>
                          <Loader width="300" height="20" />
                        </td>
                        <td>
                          <Loader width="300" height="70" />
                        </td>
                        <td>
                          <Loader width="300" height="70" />
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">
                          <div className="custom-checkbox">
                            {input ?
                              <>
                                <input
                                  type="checkbox"
                                  defaultValue={1}
                                  id="course_1"
                                  name="courses[]"
                                />
                                <label htmlFor="course_1" />
                              </> : null}
                          </div>
                        </th>
                        <td>
                          <Loader width="300" height="70" />
                        </td>
                        <td>
                          <Loader width="300" height="20" />
                        </td>
                        <td>
                          <Loader width="300" height="70" />
                        </td>
                        <td>
                          <Loader width="300" height="70" />
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">
                          <div className="custom-checkbox">
                            {input ?
                              <>
                                <input
                                  type="checkbox"
                                  defaultValue={1}
                                  id="course_1"
                                  name="courses[]"
                                />
                                <label htmlFor="course_1" />
                              </> : null}
                          </div>
                        </th>
                        <td>
                          <Loader width="300" height="70" />
                        </td>
                        <td>
                          <Loader width="300" height="20" />
                        </td>
                        <td>
                          <Loader width="300" height="70" />
                        </td>
                        <td>
                          <Loader width="300" height="70" />
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">
                          <div className="custom-checkbox">
                            {input ?
                              <>
                                <input
                                  type="checkbox"
                                  defaultValue={1}
                                  id="course_1"
                                  name="courses[]"
                                />
                                <label htmlFor="course_1" />
                              </> : null}
                          </div>
                        </th>
                        <td>
                          <Loader width="300" height="70" />
                        </td>
                        <td>
                          <Loader width="300" height="20" />
                        </td>
                        <td>
                          <Loader width="300" height="70" />
                        </td>
                        <td>
                          <Loader width="300" height="70" />
                        </td>
                      </tr>

                      <tr>
                        <th scope="row">
                          <div className="custom-checkbox">
                            {input ?
                              <>
                                <input
                                  type="checkbox"
                                  defaultValue={1}
                                  id="course_1"
                                  name="courses[]"
                                />
                                <label htmlFor="course_1" />
                              </> : null}
                          </div>
                        </th>
                        <td>
                          <Loader width="300" height="70" />
                        </td>
                        <td>
                          <Loader width="300" height="20" />
                        </td>
                        <td>
                          <Loader width="300" height="70" />
                        </td>
                        <td>
                          <Loader width="300" height="70" />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="card-footer bg-transparent">
                <div className="row no-gutters">
                  <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                    {/* remove active class to disable */}
                    <div className="courses-selected disable">
                      0 Courses selected
                    </div>
                  </div>
                  <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 text-right">
                    {/* remove active class to disable */}
                    <span className="units-selected disable">0 Units</span>
                    {/* subtitute active class for disabled to either make button active or inactive */}
                    <button className="btn btn-primary-big btn-border-radius-course disabled">
                      Register Courses
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {/* card for outstanding fees */}
          </div>
        </div>
        {/* end card for news display   */}
      </main>
    );
  }
}

class Course extends React.Component {
  state = {};

  render() {
    let { details, setCourses, checked } = this.props;
    checked = checked() ? 1 : 0;
    return (
      <tr>
        <th scope="row">
          <div className="custom-checkbox">
            <input
              onChange={e => {
                setCourses(e, details.unit, details.course_id);
              }}
              type="checkbox"
              checked={checked}
              defaultValue={1}
              id={details.course_id}
              name={details.course_id}
            />
            <label htmlFor={details.course_id} />
          </div>
        </th>
        <td>{details.code}</td>
        <td>{details.title}</td>
        <td>{details.unit}</td>
        <td>{details.status}</td>
      </tr>
      // <tr>
      //   <th scope="row">
      //     <div className="custom-checkbox">
      //       <input
      //         onChange={(e) => { console.log(e) }}
      //         type="checkbox"
      //         // defaultValue={1}
      //         id={details.course_id}
      //         name={details.title}
      //       />
      //       <label htmlFor="course_2" />
      //     </div>
      //   </th>
      //   <td>{details.code}</td>
      //   <td>
      //     {details.title}
      //   </td>
      //   <td>{details.unit}</td>
      //   <td>{details.status}</td>
      // </tr>
    );
  }
}

class UnitsDetails extends React.Component {
  componentDidMount() { }
  render() {
    return (
      <div className="row no-gutters">
        <div className="col-lg-12">
          <div className="card min-h-auto">
            <div className="card-body">
              <div
                className="course-overview-slider owl-carousel owl-theme"
                ref={el => (this.courseOverviewSlider = el)}
              >
                <div className="course-overview p-0 text-center">
                  <div className="course-border">
                    <div className="number m-0 fs-36-l">36</div>
                    <p>Minimum Units Required</p>
                  </div>
                </div>
                <div className="course-overview p-0 text-center">
                  <div className="course-border">
                    <div className="number m-0 fs-36-l">48</div>
                    <p>Maximum Units Required</p>
                  </div>
                </div>
                <div className="course-overview p-0 text-center">
                  <div className="course-border">
                    <div className="number m-0 fs-36-l">42</div>
                    <p>Total Unit Registered</p>
                  </div>
                </div>
                <div className="course-overview p-0 text-center">
                  <div className="border-0 course-border">
                    <div className="number m-0 fs-36-l">0</div>
                    <p>CO/Outstanding Course(s)</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* card for outstanding fees */}
        </div>
      </div>
    );
  }
}
export default RegisterCoursesLoader;
